<template>
    <div class="py-0">
        <div class="row">
            <div class="col-md-12 mb-4">
                <div>
                    <el-collapse>
                        <el-collapse-item>
                            <template slot="title">
                                <span class="ps-2" style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                            </template>
                            <div class="px-2">
                                <el-form label-position="top" label-width="100px">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Station">
                                                <el-select v-model="spkluid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
                                                    <el-option v-for="item3 in spklu.list" :key="item3.Id" :label="item3.SpkluName" :value="item3.Id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6" v-if="tabName == 'station'">
                                            <el-form-item label="Status">
                                                <el-radio-group v-model="status" size="small" name="status">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6" v-if="tabName == 'charge-box' || tabName == 'socket'">
                                            <el-form-item label="Machine Status">
                                                <el-radio-group v-model="statusmachine" size="small" name="status">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.statusmesin" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-12" v-if="tabName == 'socket'">
                                            <el-form-item label="Socket Status">
                                                <el-radio-group v-model="statussocket" size="small" name="status">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.statussocket" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-6">
                                            <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
                                        </div>
                                    </div>
                                </el-form>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>

                <div class="row" v-if="false">
                    <div class="col-md-3 mb-2 mt-2">
                        <el-checkbox v-model="showchart">Show Chart</el-checkbox>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 mb-2">
                        <BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" :totalValue="this.totalValue"/>
                        <LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 bg-white px-4">
                        <ReportResultTable :reportname="'NFRReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess"/>  
                    </div>                   
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Spklu from '@/components/page/Spklu.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import {Rainbow, Config, AppColors, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'

export default
{
	extends:Spklu,
	components: {
        ReportResultTable,
        LineChart,
        BarChart,
    },
    props: ['tabIndex','tabName', 'tabLabel'],
    data(){
		return {
			reportdata: [],
            chartdata: [],
            showchart : false,
            stacked: true,
            charttype: 'barchart',
            totalValue: 0,

            urlRequestParams: '',
            //plant: '',
            spkluid: '',
            status: '',
            statusmachine: '',
            statussocket: '',
            //
            year: Penanggalan().tahun,
            month: Penanggalan().bulan,
            
            options: {
                area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				owner:[
					{ value: "", name: "ALL" }, 
					//{ value: "by_owner", name: "BY OWNER" }, 
					{ value: "COCO", name: "COCO" }, 
					{ value: "KSO", name: "KSO" }, 
					{ value: "TAC", name: "TAC" }, 
				],
                months:[
                    //{value:'', name: 'Ytd'},
                    {value:1, name: 'Januari'},
                    {value:2, name: 'Februari'},
                    {value:3, name: 'Maret'},
                    {value:4, name: 'April'},
                    {value:5, name: 'Mei'},
                    {value:6, name: 'Juni'},
                    {value:7, name: 'Juli'},
                    {value:8, name: 'Agustus'},
                    {value:9, name: 'September'},
                    {value:10, name: 'Oktober'},
                    {value:11, name: 'November'},
                    {value:12, name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                    {value:'2024', name: '2024'},
                    {value:'2025', name: '2025'},
                ],

                status :[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "Aktif" }, 
					{ value: "0", name: "Tidak Aktif" }, 
				],
                statusmesin:[
					{ value: "", name: "ALL" }, 
					{ value: "Connected", name: "Connected" }, 
					{ value: "Disconnected", name: "Disconnected" }, 
				],
                statussocket:[
					{ value: "", name: "ALL" }, 
					{ value: "Available", name: "Available" }, 
					{ value: "Unavailable", name: "Unavailable" }, 
					{ value: "Faulted", name: "Faulted" }, 
					{ value: "Preparing", name: "Preparing" }, 
					{ value: "Finishing", name: "Finishing" }, 
					{ value: "Charging", name: "Charging" }, 
					{ value: "SuspendedEV", name: "SuspendedEV" }, 
				],
            },

            loading: {
                table: false,
                isSuccess: false,
            },
        }
    },
    computed:{

	},
    watch:{
        
    },
    mounted(){
        this.$emit('childrenRoute');
        this.loadStation();
        //this.getData()
    },
    methods: {
        async getData() {
            
			this.urlRequestParams = Config().apiURL
            if(this.tabName == 'station')
                this.urlRequestParams += '/v1/spklu/station?'
            else if(this.tabName == 'charge-box')
                this.urlRequestParams += '/v1/spklu/chargebox?'
            else if(this.tabName == 'socket')
                this.urlRequestParams += '/v1/spklu/socket?'

            this.urlRequestParams += '&station='+this.spkluid
			this.urlRequestParams += '&status='+this.status
			this.urlRequestParams += '&status-machine='+this.statusmachine
			this.urlRequestParams += '&status-socket='+this.statussocket

			this.urlRequestParams += '&year='+this.year
			this.urlRequestParams += '&month='+this.month

            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

        applyFilter() {
            this.getData()
        },
    }
}
</script>
